import SharedNavbar from '../../../components/feature/SharedNavbar';
import SharedFooter from '../../../components/feature/SharedFooter';
import FloatingCallButton from '../../../components/feature/FloatingCallButton';
import ServiceHero from '../components/ServiceHero';
import ServiceContent from '../components/ServiceContent';
import ServiceCTA from '../components/ServiceCTA';

export default function EmergencyWorkPage() {
  const serviceData = {
    title: 'Emergency Electrical Work',
    subtitle: '24/7 Emergency Response',
    description: 'Electrical emergencies can happen at any time. Our licensed electricians are available 24/7 to respond to your urgent electrical needs across Sydney. We prioritize safety and provide rapid response times to protect your property and loved ones.',
    heroImage: 'https://public.readdy.ai/ai/img_res/47609102ebee2ce4fa3aaf7580359ec0.jpg',
    features: [
      {
        icon: 'ri-time-line',
        title: '24/7 Availability',
        description: 'Round-the-clock emergency service, every day of the year'
      },
      {
        icon: 'ri-flashlight-line',
        title: 'Rapid Response',
        description: 'Fast arrival times to minimize damage and restore safety'
      },
      {
        icon: 'ri-shield-check-line',
        title: 'Safety First',
        description: 'Immediate hazard assessment and risk mitigation'
      },
      {
        icon: 'ri-tools-line',
        title: 'Fully Equipped',
        description: 'Complete range of tools and parts for on-site repairs'
      }
    ],
    benefits: [
      'Immediate response to electrical emergencies',
      'Licensed and insured emergency electricians',
      'Complete safety inspections included',
      'Transparent emergency pricing',
      'Power restoration services',
      'Fault finding and repairs',
      'Temporary safety measures',
      'Follow-up support and advice'
    ],
    processSteps: [
      {
        number: '01',
        title: 'Emergency Call',
        description: 'Contact us immediately via phone for urgent electrical issues'
      },
      {
        number: '02',
        title: 'Rapid Dispatch',
        description: 'Our nearest electrician is dispatched to your location'
      },
      {
        number: '03',
        title: 'Safety Assessment',
        description: 'Thorough evaluation of the emergency and immediate hazards'
      },
      {
        number: '04',
        title: 'Emergency Repair',
        description: 'Swift resolution of the issue with quality workmanship'
      }
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SharedNavbar />
      <ServiceHero 
        title={serviceData.title}
        subtitle={serviceData.subtitle}
        description={serviceData.description}
        heroImage={serviceData.heroImage}
      />
      <ServiceContent 
        features={serviceData.features}
        benefits={serviceData.benefits}
        processSteps={serviceData.processSteps}
      />
      <ServiceCTA />
      <div className="pb-20 lg:pb-0">
        <SharedFooter />
      </div>
      <FloatingCallButton />
    </div>
  );
}